export type FAQItem = {
    question: string;
    answer: string;
    orderNo: number;
};

export function getFAQData(): Promise<Array<FAQItem>> {
    return new Promise(resolve =>
        resolve([
            {
                question: 'Do you have a light system?',
                answer: `No. We are a modified as-is auction. CarMax Auctions discloses any known major mechanical issues, title brands, and structural or flood damage as outlined by the National Auto Auction Association (NAAA). Mechanical condition should be verified on our lot. See our <a href='/policy'>Auction Policies</a> for details.`,
                orderNo: 1,
            },
            {
                question: 'What types of announcements do you make about your vehicles?',
                answer: `CarMax Auctions is open and upfront with our wholesale customers. We make major mechanical announcements on vehicles that we know to have evidence of a bad motor, transmission, 4x4, front and rear differential, etc. CarMax Auctions also discloses any known title brands. Other announcements include structural damage and flood damage as outlined by the NAAA. See our <a href='/policy'>Auction Policies</a> for details`,
                orderNo: 2,
            },
            {
                question: "What if I find a problem you didn't disclose in your announcement?",
                answer: `Assuming that the issue is addressed within our <a href='/policy'>Auction Policies</a>, CarMax Auctions will take return of the vehicle or provide a price adjustment.`,
                orderNo: 3,
            },
            {
                question: 'What are your auction policies? Can I have a copy of them?',
                answer: `Our <a href='/policy'>Auction Policies</a> are posted at each auction or you can <a href="https://kmxaucteaststorage.blob.core.windows.net/xml-cms/assets/auctions-policies/8E9F118F.pdf">click here</a> to download a copy. <a href='/policy'>Auction Policies</a> can also be obtained by calling our Auction Information Line at <a href="tel:8888046604" target="_blank" rel="noreferrer">(888) 804-6604</a>.`,
                orderNo: 4,
            },
            {
                question: 'Do you offer simulcast or online auctions?',
                answer: 'Yes, all auction locations offer online bidding to registered customers.',
                orderNo: 5,
            },
            {
                question: 'Is there a document with this simulcast information on it?',
                answer: 'For commonly asked questions about our virtual auctions <a href="http://image.email-carmax.com/lib/fe5015707c6303747213/m/1/35c1e29d-b258-4ee7-b287-53a0008553f3.pdf?_ga=2.188196456.1540349731.1610463021-1241735853.1603985127">click here</a>.',
                orderNo: 6,
            },
            {
                question: 'Who should I call if I have any questions?',
                answer: 'Please call our Auction Information Line at <a href="tel:8888046604" target="_blank" rel="noreferrer">(888) 804-6604</a> with any questions.',
                orderNo: 7,
            },
            {
                question: 'Can anyone buy a vehicle at a CarMax auction? Is it open to the public?',
                answer: 'CarMax auctions are DEALER ONLY auctions. All individuals attending a CarMax auction must be signed up as a representative of a licensed dealership.',
                orderNo: 8,
            },
            {
                question: 'Can I test drive your vehicles before I bid on them?',
                answer: 'Unfortunately, our facilities do not have the space to test drive the vehicles. CarMax announces known major mechanical conditions on its vehicles and recommends that a dealer verify mechanical condition before removing a vehicle from our lot.',
                orderNo: 9,
            },

            {
                question: 'How do I register for CarMax Auctions?',
                answer: `<a href="${process.env.AUCTIONS_WCS_URL}/Register">Registering online</a> is your easiest and most efficient option. If you prefer paper registration, <a href="https://www.carmaxauctions.com/paperregister.aspx">click here</a>. You can also call our Auction Information Line at <a href="tel:8888046604" target="_blank" rel="noreferrer">(888) 804-6604</a> to have the registration application sent to you. Onsite registration is available at each CarMax Auctions location on auction day, but we recommend that you register in advance to avoid any delays prior to the sale.`,
                orderNo: 10,
            },
        ])
    );
}
